import X from "lucide-react/dist/esm/icons/x";
import { useEffect, useRef } from "react";

export function Dialog({ title, children, onClose, className = "" }: { title: string; children: React.ReactNode; onClose(): void; className?: string | undefined }) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => { ref.current?.showModal(); }, []);
  return <dialog ref={ref} className={`retro-dialog ${className}`.trim()} onCancel={onClose} onClick={(event) => { if (event.target === ref.current) onClose(); }}>
    <div className="dialog-title"><span>{title}</span><button aria-label="Close dialog" onClick={onClose}><X size={13} /></button></div>
    <div className="dialog-body">{children}</div>
  </dialog>;
}
